import React, { useEffect, useMemo, useRef, useState } from "react";
import { MenuItem, Popover } from "@mui/material";
import { CustomButton, CustomDialog, CustomTextField, icon } from "../../../../../../common/components";
import { translate } from "../../../../../../common/providers";
import styles from "./DSICompanyBuCreationDialog.module.css";
import { isNonEmptyArray } from "../../../../../../common/utils";

const DSICompanyBuCreationDialog = ({ activeUsersInCompany, onClose, onCreate, open, parent, defaultName = "" }) => {
	const [name, setName] = useState("");
	const [selectedUser, setSelectedUser] = useState(null);
	const [isOpenUserList, setIsOpenUserList] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");
	const anchorRefUser = useRef(null);
	const title = useMemo(() => {
		if (defaultName) {
			return translate("dsi.dsi-company.update-name");
		}
		return parent ? translate("dsi.dsi-company.title-bu") : translate("dsi.dsi-company.company.create");
	}, [defaultName, parent]);
	useEffect(() => {
		setName(defaultName);
	}, [defaultName]);
	const handleClose = () => {
		setName("");
		setSelectedUser(null);
		setIsOpenUserList(false);
		setSearchQuery("");
		onClose();
	};
	const handleOpenUserList = () => {
		setIsOpenUserList((prevOpen) => !prevOpen);
	};
	const handleCloseUserList = () => {
		setIsOpenUserList(false);
	};
	const handleSearchChange = (event) => {
		setSearchQuery(event.target.value);
	};
	const handleSubmit = () => {
		if (typeof onCreate === "function") {
			if (parent && !defaultName) {
				onCreate(name, parent?.id, selectedUser?.id);
			} else {
				onCreate(name);
			}
		}
		handleClose();
	};
	const handleChangeName = (e) => {
		setName(e.target.value);
	};
	const handleSelectUser = (user) => {
		setSelectedUser(user);
		setIsOpenUserList(false);
	};
	return (
		<CustomDialog
			open={open}
			submitDisabled={name?.length === 0 || (parent ? !selectedUser : false)}
			title={title}
			onClose={handleClose}
			onSubmit={handleSubmit}
		>
			<div className={styles.container}>
				{parent && (
					<div className={styles.inlineContainer}>
						<div className={styles.title}>{translate("dsi.company-row.parent-company")}</div>
						<div className={styles.immutableField}>{parent?.companyName}</div>
					</div>
				)}
				<div className={styles.inlineContainer}>
					<div className={styles.title}>
						{translate("dsi.dsi-company.th.name")}
						<span className={styles.required}>*</span>
					</div>
					<CustomTextField
						className={styles.textfield}
						placeholder={
							parent
								? translate("dsi.dsi-company.enter-bu-name")
								: translate("dsi.dsi-company.enter-company-name")
						}
						value={name}
						onChange={handleChangeName}
					/>
				</div>
				{parent && (
					<div className={styles.inlineContainer}>
						<div className={styles.title}>{`${translate("dsi.dsi-company.admin-bu.select-admin")}*`}</div>
						<div className={styles.immutableField}>
							<div className={styles.titleName}>{`${translate(
								"dsi.dsi-company.admin-bu.select-admin"
							)}*`}</div>
							<CustomButton
								ref={anchorRefUser}
								autoTranslate="no"
								className={styles.userMenu}
								color="secondary"
								endIcon={icon.faChevronDown}
								size="md"
								variant="outlined"
								onClick={handleOpenUserList}
							>
								{selectedUser
									? selectedUser.displayName
									: translate("dsi.dsi-company.admin-bu.select-user")}
							</CustomButton>
							<Popover
								anchorEl={anchorRefUser.current}
								anchorOrigin={{
									vertical: "bottom",
									horizontal: "left",
								}}
								open={isOpenUserList}
								onClose={handleCloseUserList}
							>
								<div className={styles.dividerSpace}>
									<CustomTextField
										autoFocus
										fullWidth
										placeholder={translate("common:search-label.user")}
										value={searchQuery}
										variant="outlined"
										onChange={handleSearchChange}
									/>
								</div>
								{isNonEmptyArray(activeUsersInCompany) ? (
									activeUsersInCompany
										.filter((user) =>
											user?.displayName?.toLowerCase().includes(searchQuery.toLowerCase())
										)
										.map((user) => (
											<MenuItem
												key={user.id}
												className={styles.userMenu}
												onClick={() => handleSelectUser(user)}
											>
												{user.displayName}
											</MenuItem>
										))
								) : (
									<MenuItem disabled>
										{translate("common:filters.select-filter.empty-state")}
									</MenuItem>
								)}
							</Popover>
						</div>
					</div>
				)}
			</div>
		</CustomDialog>
	);
};

export default DSICompanyBuCreationDialog;
